var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"ripple",rawName:"v-ripple",value:(_vm.isUnclickable ? false : { class: 'grey--text lighten-5' }),expression:"isUnclickable ? false : { class: 'grey--text lighten-5' }"}],staticClass:"floating-button",class:( _obj = {
    'is-unclickable': _vm.isUnclickable,
    'is-center-position': _vm.isCenterPosition,
    'is-static-position': _vm.isStaticPosition,
    'has-bottom-margin-for-mobile-nav-bar': _vm.hasBottomMarginForMobileNavBar
  }, _obj[("is-type-of-" + _vm.type)] = true, _obj ),attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }